import {
    IDocumentUploadTemplateTypeLookupData,
    IExcelMappingData,
} from 'store/slices/document-upload-template/document-upload-template-slice-type';

export interface ISettingTemplateTransferTargetData{
    targetField: string;
    sourceField?: string;
    sourceFieldDynamicSQL?: string;
    sourceFieldConstant?: string;
    description?: string;
    fieldTypeId: string;
    fieldFormat?: string;
    fieldRegex?: string;
}
export const convertSettingTemplateTransferTargetFieldsData = (
    lookupData: IDocumentUploadTemplateTypeLookupData[] = [],
    mappingData: IExcelMappingData[] = [],
): ISettingTemplateTransferTargetData[] => {
    const mappingDataByTargetField = mappingData.reduce((acc, item) => {
        acc[item.targetField] = item;
        return acc;
    }, {} as Record<string, IExcelMappingData>);

    return lookupData.map(el => {
        const mapping = mappingDataByTargetField[el.lookupCode] || {}; // Получаем соответствие или пустой объект
        return {
            targetField: el.lookupCode,
            sourceField: mapping.sourceField,
            sourceFieldDynamicSQL: mapping.sourceFieldDynamicSQL,
            sourceFieldConstant: mapping.sourceFieldConstant,
            description: mapping.description,
            fieldTypeId: el.meaning,
            fieldFormat: mapping.fieldFormat,
            fieldRegex: mapping.fieldRegex,
        };
    });
};
